/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Initial allocation status
 */
export enum AllocationStatus {
  SCHEDULED = 'SCHEDULED',
  AWAITING_DEPENDENCY = 'AWAITING_DEPENDENCY',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}
